import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3395de90")

_pushScopeId("data-v-3395de90")
const _hoisted_1 = { class: "panel-list" }
const _hoisted_2 = { class: "panel-list-item-title" }
const _hoisted_3 = { class: "panel-list-item-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.column, (item) => {
      return _withDirectives((_openBlock(), _createBlock("div", {
        class: "panel-list-item",
        key: `${item.prop}`
      }, [
        _createVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, `${item.prop}Title`, {
            value: _ctx.data[item.prop],
            labelValue: item.label
          }, () => [
            _createTextVNode(_toDisplayString(item.label), 1)
          ])
        ]),
        _createVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, item.prop, {
            value: _ctx.data[item.prop]
          }, () => [
            _createTextVNode(_toDisplayString(_ctx.data[item.prop]), 1)
          ])
        ])
      ], 512)), [
        [_vShow, item.show||item.show===undefined]
      ])
    }), 128))
  ]))
})